<template>
  <b-button
    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
    variant="flat-info"
    class="btn-icon rounded-circle"
    v-b-tooltip.hover.v-info="{ title: $t('Duplicate'), placement }"
    @click="$emit('clicked')"
  >
    <feather-icon icon="CopyIcon" />
  </b-button>
</template>

<script >
import Ripple from 'vue-ripple-directive'
import { VBTooltip } from 'bootstrap-vue'

export default {
  name: 'DuplicateButton',
  directives: {
    Ripple,
    'b-tooltip': VBTooltip,
  },
  props: {
    placement: {
      type: String,
      default: 'top',
    },
  }
}
</script>

<style scoped>

</style>
